import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { SGSRadio, SGSRadioProps } from 'components';
import { useTranslation } from 'react-i18next';

type Props = SGSRadioProps;

const SGSFormRadio: React.FC<Props> = ({ name, label, options, ...props }) => {
    const { control } = useFormContext();
    const { t } = useTranslation();
    return (
        <Controller {...props} name={name} control={control} render={({ field }) => <SGSRadio {...field} row={props.row} label={t(label as string)} value={field.value || ''} options={options} />} />
    );
};

export default SGSFormRadio;
